import { render, staticRenderFns } from "./abs_table.vue?vue&type=template&id=1dec36a2&lang=pug&"
import script from "./abs_table.vue?vue&type=script&lang=coffee&"
export * from "./abs_table.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports